export class ParticipantModel {
   "studyId":Number;
   "roleId":Number;
   "userId":Number;
   "doctorId":Number;
 }